import { createIcon } from '../createIcon';

export const PluggedIconConfig = {
  name: 'PluggedIcon',
  height: 1024,
  width: 704,
  svgPath: 'M64,448 C73.8,555.7 76.7,807.9 256,850.2 L256,1024 L448,1024 L448,851.6 C627.2,807.9 626,603.2 640,448 L64,448 Z M576,256 L576,32.2 C576,14.5 561.6,0.1 543.8,0.2 L479.8,0.5 C462.2,0.6 448,14.9 448,32.5 L448,256 L256,256 L256,32 C256,14.3 241.7,0 224,0 L160,0 C142.3,0 128,14.3 128,32 L128,256 L0,256 L0,384 L704,384 L704,256 L576,256 Z',
  yOffset: 0,
  xOffset: 0,
};

export const PluggedIcon = createIcon(PluggedIconConfig);

export default PluggedIcon;